// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__JTOSt","favoritesBtn":"styles_favoritesBtn__WFq6Y"};